import { render } from "./TransferDocumentValidationContainer.vue?vue&type=template&id=a7afd1bc"
import script from "./TransferDocumentValidationContainer.vue?vue&type=script&lang=js"
export * from "./TransferDocumentValidationContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__